import { UIFilters } from '../types'

interface RangeFilterLabels {
  label: string
  range: string
  min: string
  max: string
}

export type RangeFilterValue = {
  min?: number
  max?: number
}

type ValidationResult = {
  [K in keyof UIFilters]: {
    helperText: string
  }
}

export const createRangeFilterChip = (
  key: keyof UIFilters,
  value: RangeFilterValue | undefined,
  labels: RangeFilterLabels,
) => {
  if (!value) return undefined
  const { min, max } = value
  const { label, range, min: minLabel, max: maxLabel } = labels

  if (min != undefined && max != undefined) {
    return {
      key,
      label: `${label}: ${range.replace('{min}', min.toString()).replace('{max}', max.toString())}`,
    }
  } else if (min != undefined) {
    return {
      key,
      label: `${label}: ${minLabel.replace('{value}', min.toString())}`,
    }
  } else if (max != undefined) {
    return {
      key,
      label: `${label}: ${maxLabel.replace('{value}', max.toString())}`,
    }
  }
  return undefined
}

export const validateRangeFilter = (
  value: RangeFilterValue | undefined,
  key: keyof UIFilters,
): Partial<ValidationResult> => {
  if (!value) return {}

  if (value.min !== undefined && value.min < 1) {
    return {
      [key]: {
        helperText: 'Minimum must be greater than 0',
      },
    } as Partial<ValidationResult>
  }

  if (value.max !== undefined && value.max < 1) {
    return {
      [key]: {
        helperText: 'Maximum must be greater than 0',
      },
    } as Partial<ValidationResult>
  }

  if (value.min !== undefined && value.max !== undefined && value.min >= value.max) {
    return {
      [key]: {
        helperText: 'Must be greater than "At least"',
      },
    } as Partial<ValidationResult>
  }

  return {}
}
